import React from 'react';
import {  Text, StyleSheet, Image } from "./Primitives";
import { View } from '@react-pdf/renderer'
import {usePdfType} from "./Hooks/PdfTypeContext";
// Create styles
const styles = StyleSheet.create({
    page: {
        flexDirection: 'row',
        backgroundColor: '#E4E4E4'
    },
    image:{
       position: 'absolute',
        left:0,
        top:0,

      width:'100%',
        height:'auto'
    },
    header: {

        top:0,
        left:0,
        right:0,
        width:'100%',
        flexDirection: 'row',
        display:'flex',
        justifyContent:'space-between',
        height:100,
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1
    },
    titleText:{
        color:'white',
        position:'absolute', 
        top:30,
        left:40,
        fontSize:25,
    }
});

const Header = ({charter,bidHistory, newPdfType }) => {
    const pdfType = usePdfType();

    newPdfType=pdfType?pdfType:newPdfType;

    const qg = newPdfType === 'Itinerary' ? 'Standard' : newPdfType === 'ItineraryQGov' ?'QGov':'BidHistory';
    return <View fixed style={styles.header}>

        <Image
            style={styles.image}
            src={"/img/pdf/"+qg+"/Header.jpg"}
        />
        <Text style={styles.titleText}>{bidHistory?"Your Charter Bids":charter.title}</Text>
    </View>
}


export default Header;